export const STORAGE_KEYS = {
  USER_ID: 'userId',
  USER_NAME: 'userName',

  // 🔐 Auth related
  TOKEN: 'accessToken',
  USER: 'userDetails',

} as const;
